import Popup from 'reactjs-popup';
import Button from '@mui/material/Button';
import TicketConversation from '../TicketConversation/TicketConversation';
import "./OpenDiscussionButton.scss";

export default function OpenDiscussionButton() {
  return (
    <div className="button-container">
      <Popup 
        trigger={
          <Button variant="contained" className="open-discussion-button">
            Open Conversation
          </Button>
        } 
        modal 
        nested
        data-testid="open-discussion-popup"
      >
        {close => (
          <div className='openDiscussionModel' data-testid="open-discussion-modal">
            <div className='openDiscussionContent' data-testid="open-discussion-content">
              <TicketConversation onClose={close} data-testid="ticket-conversation"/>
            </div>    
          </div>
        )}
      </Popup>
    </div>
  );
}